import { render } from "./bottom.vue?vue&type=template&id=7888fa16&scoped=true"
const script = {}

import "./bottom.vue?vue&type=style&index=0&id=7888fa16&lang=scss&scoped=true"

import exportComponent from "D:\\WorkJob\\SmartCarRace\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7888fa16"]])

export default __exports__